import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../api/client.js'
import { useCatalog } from '../hooks/useCatalog.js'
import WeaponArt from './WeaponArt.jsx'
import '../styles/live-rail.css'

const LIVE_TILES = 30
const LIVE_POLL_MS = 6000

export default function LiveRail() {
  const { getItem } = useCatalog()
  const [drops, setDrops] = useState([])
  const [online, setOnline] = useState(1482)
  const navigate = useNavigate()

  useEffect(() => {
    let alive = true

    const load = () => {
      if (document.visibilityState === 'hidden') return
      api
        .liveDrops()
        .then(({ drops }) => {
          if (alive && drops) setDrops(drops)
        })
        .catch(() => {})
    }

    load()
    const timer = setInterval(load, LIVE_POLL_MS)
    return () => {
      alive = false
      clearInterval(timer)
    }
  }, [])

  // Живая динамика онлайна с мягкими реалистичными колебаниями
  useEffect(() => {
    const interval = setInterval(() => {
      setOnline((prev) => {
        const delta = Math.floor(Math.random() * 7) - 3
        const next = prev + delta
        return next < 1350 ? 1350 : next > 1650 ? 1650 : next
      })
    }, 6000)
    return () => clearInterval(interval)
  }, [])

  const fresh = drops.slice(0, LIVE_TILES)

  const handleTileClick = (drop) => {
    if (drop.source?.startsWith('case:')) {
      const caseId = drop.source.replace('case:', '')
      navigate(`/cases/${caseId}`)
    }
  }

  return (
    <section className="live-ticker-bar" aria-label="Лента выбитых предметов">
      <div className="live-ticker-inner">
        {/* Блок LIVE & Онлайн */}
        <div className="live-badge-wrapper">
          <div className="live-badge">
            <div className="live-badge-top">
              <span className="live-pill-tag">
                <span className="live-pulse-dot" aria-hidden="true" />
                LIVE
              </span>
              <span className="live-badge-title">ДРОПЫ</span>
            </div>

            <div className="live-badge-divider" />

            <div className="live-online-pill" title="Игроков в онлайне">
              <span className="live-online-dot" />
              <div className="live-online-text">
                <span className="live-online-count">{online.toLocaleString('ru-RU')}</span>
                <span className="live-online-sub">онлайн</span>
              </div>
            </div>
          </div>
        </div>

        {/* Сплошная лента дропов с минимальным зазором */}
        <div className="live-stream-track">
          {fresh.length === 0 ? (
            <div className="live-placeholder">Ожидание открытий...</div>
          ) : (
            <div className="live-stream-items">
              {fresh.map((drop) => {
                const item = getItem(drop.itemId)
                const isCase = drop.source?.startsWith('case:')
                const rarity = item.rarity || 'milspec'

                return (
                  <article
                    key={drop.id}
                    className={`live-drop-tile rarity-${rarity} ${isCase ? 'is-clickable' : ''}`}
                    onClick={() => handleTileClick(drop)}
                    title={`${item.name} | ${item.skin}`}
                  >
                    {/* Фоновое цветное свечение от качества */}
                    <span className="live-tile-aura" aria-hidden="true" />

                    {/* Крупный скин по центру */}
                    <div className="live-tile-art">
                      <WeaponArt
                        image={item.image}
                        rarity={item.rarity}
                        title={`${item.name} | ${item.skin}`}
                        size="md"
                      />
                    </div>

                    {/* Название скина и оружия */}
                    <div className="live-tile-info">
                      <span className="live-tile-skin">{item.skin || item.name}</span>
                      <span className="live-tile-weapon">{item.name}</span>
                    </div>

                    {/* Нижняя неоновая полоса качества */}
                    <span className="live-tile-rarity-bar" aria-hidden="true" />
                  </article>
                )
              })}
            </div>
          )}
        </div>
      </div>
    </section>
  )
}
